import { IsEnum, IsOptional, IsUUID, IsObject } from 'class-validator'
import { ApiPropertyOptional } from '@nestjs/swagger'
import { AttemptOrigin } from '../../../enums'

export class StartAttemptRequestDto {

  @ApiPropertyOptional({ type: 'string' })
  @IsUUID('4')
  activityId?: string

  @ApiPropertyOptional({ enum: AttemptOrigin })
  @IsEnum(AttemptOrigin)
  origin?: AttemptOrigin // FREE | CLASS_ASSIGNMENT | USER_ASSIGNMENT

  @ApiPropertyOptional({ type: 'string' })
  @IsOptional()
  @IsUUID('4')
  originRefId?: string // id d’assignation si applicable

  // Dénormalisations School optionnelles (pour filtres rapides)
  @ApiPropertyOptional({ type: 'string', description: "ID de la leçon" }) @IsOptional() @IsUUID('4') lessonId?: string
  @ApiPropertyOptional({ type: 'string', description: "ID de l'enseignement" }) @IsOptional() @IsUUID('4') teachingId?: string
  @ApiPropertyOptional({ type: 'string', description: "ID de la classe" }) @IsOptional() @IsUUID('4') classId?: string
  @ApiPropertyOptional({ type: 'string', description: "ID de l'établissement" }) @IsOptional() @IsUUID('4') establishmentId?: string

  @ApiPropertyOptional({ type: Object })
  @IsOptional()
  @IsObject()
  initialData?: Record<string, any>

  // Champs ignorés ou mappés pour compatibilité
  @ApiPropertyOptional({ type: Object })
  @IsOptional()
  @IsObject()
  userAnswers?: Record<string, any>

  @ApiPropertyOptional({ type: 'string' })
  @IsOptional()
  statusId?: string

  @ApiPropertyOptional({ type: Number })
  @IsOptional()
  attemptNo?: number
}
